<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title> Select a payment type </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *ngIf="showPaymentBox && !paymentError">
    <div *ngIf="readerConnected && !dropDownPushed">
      <h2 class="ion-text-center ion-padding payment-title">
        Pass the card reader to the customer to complete the sale
      </h2>
      <ion-row size="12" class="height-200">
        <salonmonster-load-mask
          [ngClass]="'center-block'"
          *ngIf="paymentProcessing"
        ></salonmonster-load-mask>
      </ion-row>
    </div>
    <div *ngIf="readerConnected && dropDownPushed">
      <ion-list>
        <ion-item tappable (click)="manualCardPayment()"
          ><strong>Card on file</strong></ion-item
        >
        <ion-item tappable (click)="manualCardPayment(true)"
          ><strong>Manual card entry</strong></ion-item
        >
        <ion-item tappable (click)="onCashSelect()">Cash</ion-item>
      </ion-list>

      <ion-accordion-group
        [value]="accordionValue"
        (ionChange)="changeAccordionValue($event)"
      >
        <ion-accordion class="ion-accordion" value="first">
          <ion-item slot="header">
            <ion-label>Track external payments</ion-label>
          </ion-item>
          <div slot="content">
            <ion-list>
              <ion-item
                tappable
                *ngFor="let payment of paymentTypes"
                (click)="onPaymentSelect(payment)"
                [disabled]="disableCashButton && payment.type == 1"
              >
                {{ payment.name }}
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
    <div *ngIf="!readerConnected">
      <ion-list>
        <ion-item *ngIf="!cardInfo" disabled tappable
          ><strong>Card on file </strong></ion-item
        >
        <ion-item *ngIf="cardInfo" (click)="manualCardPayment()" tappable
          ><strong>Card on file</strong></ion-item
        >
        <ion-item (click)="manualCardPayment(true)" tappable
          ><strong>Manual card entry</strong></ion-item
        >
        <ion-item (click)="onCashSelect()" tappable>Cash</ion-item>
      </ion-list>

      <ion-accordion-group
        [value]="accordionValue"
        (ionChange)="changeAccordionValue($event)"
      >
        <ion-accordion class="ion-accordion" value="first">
          <ion-item slot="header">
            <ion-label>Track external payments</ion-label>
          </ion-item>
          <div slot="content">
            <ion-list>
              <ion-item
                tappable
                *ngFor="let payment of paymentTypes"
                (click)="onPaymentSelect(payment)"
                [disabled]="disableCashButton && payment.type == 1"
              >
                {{ payment.name }}
              </ion-item>
            </ion-list>
          </div>
        </ion-accordion>
      </ion-accordion-group>
      <div class="reader-box" *ngIf="foundReaders && !readerConnected">
        <ion-item class="reader-disconnected-top ion-no-padding" lines="none">
          <span>Card reader not connected</span>
          <ion-button
            *ngIf="!connectPushed"
            (click)="connectCardReader()"
            slot="end"
            class="reader-reconnect-button ion-no-margin"
            >Reconnect</ion-button
          >
          <salonmonster-small-checkmark-loader
            class="reader-disconnected-loader"
            *ngIf="connectPushed"
            slot="end"
            [completed]="readerConnectSuccessful"
          ></salonmonster-small-checkmark-loader>
        </ion-item>
        <div *ngIf="cardReaderConnectError" class="reader-disconnected-bottom">
          <p class="sm-error">Oops! something went wrong</p>
          Please check your internet connection and make sure that the reader is
          powered on and connected to the internet.
        </div>
      </div>
      <!-- <div class='reader-box' *ngIf='!foundReaders'>
        <div class='reader-no-reader-top'><span>Get a payment terminal</span> <ion-button class='float-right no-reader-button'>Learn More</ion-button></div>
        <div class='reader-no-reader-bottom'>Reduce your payment costs and simplify the payment process with a payment terminal</div>
      </div> -->
    </div>
  </div>
  <div *ngIf="paymentError" class="ion-text-center">
    <h2 class="ion-padding payment-title">Payment Failed</h2>
    <h4>Card was declined</h4>
    <ion-button (click)="retry()"> Try again </ion-button>
  </div>
  <salonmonster-load-mask
    [ngClass]="'center-block'"
    *ngIf="!showPaymentBox"
  ></salonmonster-load-mask>
</ion-content>

<!-- <ion-footer *ngIf="!foundReaders&&showPaymentBox"> -->
<!-- <ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="4" class="ion-padding">
        <div class="ion-text-center">
          <img src="../../../../assets/images/wisepos-floating-tall.png" alt="card-reader" height="120"/>
        </div>
      </ion-col>
      <ion-col class="ion-padding">
        <h4>Get a payment terminal</h4>
        <div>
          Reduce your payments costs and simplify the payment process. <a routerLink="settings/payment-processing-settings" color="primary">Learn more</a>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer> -->
